export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "ar-AE": {
        "adminSettings": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["إعدادات المسؤول"])}
        }
      },
      "ar-EG": {
        "adminSettings": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["إعدادات المسؤول"])}
        }
      },
      "ar-SA": {
        "adminSettings": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["إعدادات المسؤول"])}
        }
      },
      "de-DE": {
        "adminSettings": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Administratoreinstellungen"])}
        }
      },
      "de-AT": {
        "adminSettings": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Administratoreinstellungen"])}
        }
      },
      "de-CH": {
        "adminSettings": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Administratoreinstellungen"])}
        }
      },
      "en-US": {
        "adminSettings": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Administrator Settings"])}
        }
      },
      "en-GB": {
        "adminSettings": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Administrator Settings"])}
        }
      },
      "it-IT": {
        "adminSettings": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Impostazioni amministratore"])}
        }
      },
      "fr-FR": {
        "adminSettings": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Paramètres administrateur"])}
        }
      },
      "es-ES": {
        "adminSettings": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Configuraciones de administrador"])}
        }
      },
      "pl-PL": {
        "adminSettings": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ustawienia administratora"])}
        }
      },
      "nl-NL": {
        "adminSettings": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Beheerdersinstellingen"])}
        }
      },
      "bg-BG": {
        "adminSettings": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Настройки на администратора"])}
        }
      },
      "bs-BA": {
        "adminSettings": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Postavke administratora"])}
        }
      },
      "da-DK": {
        "adminSettings": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Administratorindstillinger"])}
        }
      },
      "et-EE": {
        "adminSettings": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Administraatori seaded"])}
        }
      },
      "fi-FI": {
        "adminSettings": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Järjestelmänvalvojan asetukset"])}
        }
      },
      "el-GR": {
        "adminSettings": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ρυθμίσεις διαχειριστή"])}
        }
      },
      "he-IL": {
        "adminSettings": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["הגדרות מנהל"])}
        }
      },
      "ga-IE": {
        "adminSettings": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Socruithe riarthóra"])}
        }
      },
      "ja-JP": {
        "adminSettings": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["管理者設定"])}
        }
      },
      "hr-HR": {
        "adminSettings": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Postavke administratora"])}
        }
      },
      "lv-LV": {
        "adminSettings": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Administratora iestatījumi"])}
        }
      },
      "lt-LT": {
        "adminSettings": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Administratoriaus nustatymai"])}
        }
      },
      "pt-PT": {
        "adminSettings": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Configurações de administrador"])}
        }
      },
      "ro-RO": {
        "adminSettings": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Setări administrator"])}
        }
      },
      "ru-RU": {
        "adminSettings": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Настройки администратора"])}
        }
      },
      "sv-SE": {
        "adminSettings": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Administratörsinställningar"])}
        }
      },
      "sk-SK": {
        "adminSettings": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nastavenia správcu"])}
        }
      },
      "cs-CZ": {
        "adminSettings": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nastavení správce"])}
        }
      },
      "tr-TR": {
        "adminSettings": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Yönetici ayarları"])}
        }
      },
      "hu-HU": {
        "adminSettings": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Rendszergazda beállításai"])}
        }
      },
      "fr-BE": {
        "adminSettings": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Paramètres administrateur"])}
        }
      },
      "fr-LU": {
        "adminSettings": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Paramètres administrateur"])}
        }
      },
      "mt-MT": {
        "adminSettings": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Is-settings tal-amministratur"])}
        }
      },
      "sl-SI": {
        "adminSettings": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nastavitve skrbnika"])}
        }
      },
      "el-CY": {
        "adminSettings": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ρυθμίσεις διαχειριστή"])}
        }
      },
      "tr-CY": {
        "adminSettings": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Yönetici ayarları"])}
        }
      },
      "uk-UA": {
        "adminSettings": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Налаштування Адміністратора"])}
        }
      },
      "zh-CN": {
        "adminSettings": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["管理员设置"])}
        }
      }
    }
  })
}
